// extracted by mini-css-extract-plugin
module.exports = {"sliderThumb":"_e16bc72","sliderTrack":"_85a92ba","sliderRail":"_b41912a","sliderMark":"_258696f","description":"_5426f24","stakes":"_137ec9a","buyIn":"_c377896","error":"_0321155"};